webpackJsonp([0],{

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(37),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pluralize;
/* harmony export (immutable) */ __webpack_exports__["b"] = isShortUrl;
function pluralize(n, verb) {
  return n + (n === 1 ? " " + verb : " " + verb + "s");
}

function isShortUrl(url) {
  var regex = /^item\?id=\d+/i;
  return regex.test(url);
}

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostsList__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PostsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PostsList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    PostsList: __WEBPACK_IMPORTED_MODULE_0__PostsList___default.a
  },
  data: function data() {
    return {
      posts: [],
      type: this.$route.name,
      page: this.$route.params.page ? parseInt(this.$route.params.page, 10) : 1,
      hasMore: true
    };
  },

  computed: {
    start: function start() {
      return (this.page - 1) * 30 + 1;
    }
  },
  created: function created() {
    if (window.hnpwaVueApiRes) {
      this.posts = window.hnpwaVueApiRes;
      window.hnpwaVueApiRes = null;
    } else {
      this.fetchData();
    }
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      fetch('https://node-hnapi.herokuapp.com/' + this.type + '?page=' + this.page).then(function (res) {
        if (res.ok) return res.json();
        throw new Error('API response error');
      }).then(function (res) {
        _this.posts = res;
        _this.hasMore = res.length === 30;
        window.hnpwaVueApiRes = null;
      }).catch(function (e) {
        return console.error(e.message);
      });
    }
  }
});

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'posts-list',
  props: {
    posts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    start: {
      type: Number,
      default: function _default() {
        return 1;
      }
    }
  },
  methods: {
    pluralize: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* pluralize */],
    isShortUrl: __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* isShortUrl */]
  }
});

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(true);
// imports


// module
exports.push([module.i, ".list-item{padding:15px 10px}.post-title{font-size:16px;color:#333}.comment-link{color:inherit}.comment-link:hover{color:#4dba87}", "", {"version":3,"sources":["/Users/grofers/mygithub/hnpwa-vue/src/components/PostsList.vue"],"names":[],"mappings":"AACA,WACE,iBAAmB,CACpB,AACD,YACE,eAAgB,AAChB,UAAY,CACb,AACD,cACE,aAAe,CAChB,AACD,oBACE,aAAe,CAChB","file":"PostsList.vue","sourcesContent":["\n.list-item {\n  padding: 15px 10px;\n}\n.post-title {\n  font-size: 16px;\n  color: #333;\n}\n.comment-link {\n  color: inherit;\n}\n.comment-link:hover {\n  color: #4dba87;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(true);
// imports


// module
exports.push([module.i, ".main{margin-top:100px;background:#fff;margin-bottom:12px;overflow:hidden}.pagination{position:fixed;top:49px;left:0;right:0;background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.18);text-align:center;z-index:5}.pagination-link{padding:8px 12px;display:inline-block;font-size:16px}.disabled{color:#ccc}.no-overflow{overflow:hidden}", "", {"version":3,"sources":["/Users/grofers/mygithub/hnpwa-vue/src/components/Home.vue"],"names":[],"mappings":"AACA,MACE,iBAAkB,AAClB,gBAAiB,AACjB,mBAAoB,AACpB,eAAiB,CAClB,AACD,YACE,eAAgB,AAChB,SAAU,AACV,OAAQ,AACR,QAAS,AACT,gBAAiB,AACjB,qCAA0C,AAC1C,kBAAmB,AACnB,SAAW,CACZ,AACD,iBACE,iBAAkB,AAClB,qBAAsB,AACtB,cAAgB,CACjB,AACD,UACE,UAAY,CACb,AACD,aACE,eAAiB,CAClB","file":"Home.vue","sourcesContent":["\n.main {\n  margin-top: 100px;\n  background: #fff;\n  margin-bottom: 12px;\n  overflow: hidden;\n}\n.pagination {\n  position: fixed;\n  top: 49px;\n  left: 0;\n  right: 0;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);\n  text-align: center;\n  z-index: 5;\n}\n.pagination-link {\n  padding: 8px 12px;\n  display: inline-block;\n  font-size: 16px;\n}\n.disabled {\n  color: #ccc;\n}\n.no-overflow {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(24);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(16)("b441cf4c", content, true, {});

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(27);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(16)("6e238804", content, true, {});

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(34),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    attrs: {
      "start": _vm.start
    }
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      staticClass: "list-item"
    }, [(_vm.isShortUrl(post.url)) ? _c('router-link', {
      staticClass: "post-title",
      attrs: {
        "to": {
          name: 'commentsList',
          params: {
            id: post.id
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(post.title) + "\n    ")]) : _c('a', {
      staticClass: "post-title",
      attrs: {
        "href": post.url,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v("\n      " + _vm._s(post.title) + "\n    ")]), _vm._v(" "), (post.domain) ? _c('span', {
      staticClass: "txt-grey"
    }, [_vm._v("\n      (" + _vm._s(post.domain) + ")\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "txt-grey"
    }, [(post.points !== null) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.pluralize(post.points, 'point')) + "\n      ")]) : _vm._e(), _vm._v(" "), (post.user) ? _c('span', [_vm._v("by "), _c('b', [_vm._v(_vm._s(post.user))])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(post.time_ago) + " |")]), _vm._v(" "), _c('router-link', {
      staticClass: "comment-link",
      attrs: {
        "to": {
          name: 'commentsList',
          params: {
            id: post.id
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.pluralize(post.comments_count, 'comment')) + "\n      ")])], 1)], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pagination"
  }, [(_vm.page > 1) ? _c('router-link', {
    staticClass: "pagination-link",
    attrs: {
      "to": '/' + _vm.type + '/' + (_vm.page - 1)
    }
  }, [_vm._v("\n      < Prev\n    ")]) : _c('a', {
    staticClass: "pagination-link disabled"
  }, [_vm._v("< Prev")]), _vm._v(" "), (_vm.hasMore) ? _c('router-link', {
    staticClass: "pagination-link",
    attrs: {
      "to": '/' + _vm.type + '/' + (_vm.page + 1)
    }
  }, [_vm._v("\n      Next >\n    ")]) : _c('a', {
    staticClass: "pagination-link disabled"
  }, [_vm._v("Next >")])], 1), _vm._v(" "), (!_vm.posts.length) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _vm._v(" "), _c('posts-list', {
    attrs: {
      "posts": _vm.posts,
      "start": _vm.start
    }
  })], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.186532ac25ae4c7b4e9e.js